export default __webpack_public_path__ + "static/media/dao-2.281bac22.png";